import RouteSwitch from "../../helpers/routeSwitch";
import UsersList from "../components/usersList/usersList";
import {UserRoles} from "../../helpers/userRoles";
import ModifyUser from "../components/modifyUser/modifyUser";
import AddUser from "../components/addUser/addUser";

export enum administrationRoutingAddress {
    users = "/users",
    list = "/users/list",
    add = "/users/add-user",
    modify = "/users/modify-user"
}

export const administrationRoutes = [
    {
        path: administrationRoutingAddress.users,
        component: RouteSwitch,
        routes: [
            {
                path: administrationRoutingAddress.list,
                component: UsersList,
                roles: [UserRoles.usersView]
            },
            {
                path: administrationRoutingAddress.add,
                component: AddUser,
                roles: [UserRoles.userModification]
            },
            {
                path: `${administrationRoutingAddress.modify}/:id`,
                component: ModifyUser,
                roles: [UserRoles.userModification]
            },
        ]
    },
];
